import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIndicatorPageIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 228 168"
    {...props}
  >
    <path
      stroke="#4CAF50"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={22.926}
      strokeWidth={3.993}
      d="M28.627 112.289v25.191M16.03 124.883h25.193"
    />
    <path
      fill="#FFB800"
      fillRule="evenodd"
      d="M220.893 80.58c7.861-16.015 2.998-28.87-.865-35.56a36.54 36.54 0 0 0-13.19 12.843 36.5 36.5 0 0 0-5.264 17.645 62 62 0 0 0 .692 12.548l11.63 3.118a63.5 63.5 0 0 0 6.997-10.594m-11.671 28.042c.553-3.072-1.303-6.227-4.355-7.026a6.17 6.17 0 0 0-4.387.566 6.12 6.12 0 0 0-2.888 3.347c-1.901 5.227 2.179 15.129 2.179 15.129s8.484-6.538 9.451-12.016m18.766-15.748c.237-3.687-3.011-7.931-5.19-10.348a80.7 80.7 0 0 1-7.493 11.094l5.686 9.849s6.669-5.654 6.997-10.595m-28.909-16.71c-3.105.946-8.206 2.957-9.865 6.317-2.191 4.44.758 12.675.758 12.675l9.955-5.748a80 80 0 0 1-.848-13.245"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      stroke="#6FA9FF"
      strokeMiterlimit={22.926}
      strokeWidth={0.998}
      d="M58.138 1.176h76.097l42.026 41.885v120.95c0 1.672-1.41 3.077-3.089 3.077H58.138c-1.733 0-3.138-1.413-3.138-3.077V4.252c0-1.663 1.405-3.076 3.138-3.076Z"
    />
    <path
      fill="#4B7EFF"
      fillRule="evenodd"
      d="M149.994 107.755c-7.841 1.831-14.19 5.28-18.918 10.299-4.772 5.059-8.058 11.737-9.766 20.07-.176.701-.831 1.139-1.487 1.004a1.27 1.27 0 0 1-.922-1.004c-1.749-8.374-5.034-15.097-9.807-20.115-4.772-5.06-11.077-8.464-18.876-10.254-.7-.177-1.094-.873-.963-1.57.131-.524.529-.917 1.008-1.003 7.84-1.877 14.19-5.326 18.962-10.386 4.728-5.018 7.968-11.65 9.676-19.988.131-.696.791-1.135 1.446-1.004.525.132.877.57.963 1.09 1.753 8.292 5.035 14.97 9.807 20.03 4.732 5.018 11.036 8.467 18.877 10.258.655.172 1.094.868.963 1.569-.136.524-.484.872-.963 1.004M114.42 45.41c-5.518 1.221-9.939 3.495-13.269 6.81q-4.99 4.97-6.829 13.22a.806.806 0 0 1-1.008.614c-.352-.045-.569-.307-.655-.615-1.229-5.538-3.507-9.947-6.833-13.265-3.371-3.314-7.75-5.543-13.223-6.764-.484-.086-.791-.52-.656-1.003.041-.349.348-.61.697-.652 5.477-1.266 9.897-3.535 13.268-6.854 3.285-3.314 5.563-7.677 6.747-13.134.086-.48.565-.787 1.004-.697.352.086.614.394.7.742 1.23 5.453 3.503 9.86 6.833 13.175 3.326 3.319 7.706 5.588 13.224 6.768.438.086.745.52.655 1-.086.352-.348.614-.655.655"
      clipRule="evenodd"
    />
    <path
      fill="#6FA9FF"
      fillOpacity={0.149}
      fillRule="evenodd"
      d="M96.014.414h38.536l42.473 42.328v121.269c0 2.094-1.754 3.839-3.855 3.839h-37.922z"
      clipRule="evenodd"
    />
    <path
      fill="#6FA9FF"
      fillRule="evenodd"
      d="M134.546.414v38.444c0 2.139 1.753 3.884 3.9 3.884h38.577z"
      clipRule="evenodd"
    />
    <path
      fill="#F43F5E"
      fillRule="evenodd"
      d="M38.122 56.963c-.397-3.638-3.945-6.068-7.484-5.121l-6.739 1.806a1.993 1.993 0 0 1-2.441-1.405l-1.823-6.805a4.906 4.906 0 0 0-6.014-3.47 1.63 1.63 0 0 0-1.192 1.324l-2.687 17.05c-.05.3-.164.578-.328.816l5.796 21.627 20.057-5.375a5.976 5.976 0 0 0 4.395-6.424zM6.74 62.37l-3.785 1.016a3.98 3.98 0 0 0-2.815 4.88l3.61 13.466a3.983 3.983 0 0 0 4.878 2.819l3.781-1.017z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIndicatorPageIcon;
